<template>
  <router-link
    :to="{
                name: 'customerCart',
                params: { userSlug: rawMenu.user.slug },
              }"
    v-if="rawMenu && onlineMenuEnabled && cartItems.length"
    class="btn btn-block mt-3
            add-to-cart animate__animated animate__fadeIn"
  >
    <div class="details-container"><span class="d-block">View order <span>| <span class="font-weight-bold">{{ rawMenu.user.currency.symbol
                                }}{{ orderAmount | centsToDollars }}</span></span></span>
      <div class="cart-count">{{ cartItemCount }}</div>
    </div>
  </router-link>
</template>

<style scoped>
.add-to-cart {
  position: fixed;
  bottom: 0;
  text-align: center;
  font-weight: 600;
  color: #fff;
  padding: 1rem;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  cursor: pointer;
  border-radius: 10rem;
  font-size: 1.3rem;
  width: 90%;
  margin: 5%;
}
.details-container {
  position: relative;
}
.cart-count {
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: var(--user-highlight-color);
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-color: #fff;
  font-size: 1rem;
  position: absolute;
  left: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 1400px) {
  .add-to-cart {
    width: 20%;
    margin-left: 40%;
    margin-bottom: 1rem;
  }
}
</style>

<script>
import menuMixin from "../../mixins/menuMixin";
import accountingMixin from "../../mixins/accountingMixin";
import cartMixin from "../../mixins/cartMixin";
export default {
  mounted() {},
  data() {
    return { cartItemCount: 0 };
  },
  methods: {},
  computed: {
    orderAmount: function () {
      let amount = 0;
      this.cartItemCount = 0;
      let _self = this;
      _.forEach(this.cartItems, function (iValue, iKey) {
        let itemAmount = 0;
        _.forEach(iValue.prices, function (pValue, cKey) {
          if (pValue.selected) {
            itemAmount = itemAmount + pValue.amount;
          }
        });

        _.forEach(iValue.options, function (cValue, cKey) {
          if (cValue.selected) {
            itemAmount = itemAmount + cValue.amount;
          }
        });
        _.forEach(iValue.option_groups, function (cValue, cKey) {
          _.forEach(cValue.options, function (oValue, cKey) {
            if (oValue.selected) {
              itemAmount = itemAmount + oValue.amount;
            }
          });
        });
        itemAmount = itemAmount * iValue.quantity;
        amount = amount + itemAmount;
        _self.cartItemCount += iValue.quantity;
      });

      return amount;
    },
  },
  mixins: [menuMixin, accountingMixin, cartMixin],
};
</script>
